import { h, Component } from 'preact';
// import style from './style';
// import {JavaScriptIcon, ReactIcon, ReduxIcon, FirebaseIcon, NodeIcon, ExpressIcon, GithubIcon} from './../Icons'
import ImageUploader from './../imageuploader'

export default class Work extends Component {
	render() {
		return (
      <section class="Content border">

				<div class="Container small">
					<div class="Title center margin60">
						<span class="text">Work</span>
						<span class="subtext">Full Stack Developer at Lunaris Japan. 2017 - present</span>
					</div>
				</div>

				<div class="Container small">
					<div class="Title small">
						<span class="text">General</span>
					</div>
					<ul>
						<li>
							<p>
								Maintaining, developing and fixing core business applications used extensively by the company.
							</p>
						</li>
						<li>
							<p>
								- Currently redesigning and building a new, improved stock management and fulfillment system.
							</p>
						</li>
						<li>
							<p>
								- Designed and developed a streamlined customer photo request proccess, saving 4-5 hours a week. <strong>See below</strong>
							</p>
						</li>
					</ul>


					<div class="Box list">

						<div class="Title small">
							<span class="text">Billing</span>
							<span class="subtext">Changing cards, billing cycles, cancellation, and redeeming coupons.</span>
						</div>
						
							<div class="Title small">
								<span class="text">Checks</span>
								<span class="subtext">Learn how to configure checks to monitor websites, apps, and APIs.</span>
							</div>



							<a href="/docs/ping/pagerduty/">
								<div class="Title small">
									<span class="text">PagerDuty</span>
									<span class="subtext">Set up on-call alert notifications with our PagerDuty integration.</span>
								</div>
							</a>



							<a href="/docs/ping/ssl/">
								<div class="Title small">
									<span class="text">SSL Certificate Expiration</span>
									<span class="subtext">Receive notifications when an SSL certificate is soon to be expired.</span>
								</div>
							</a>



							<a href="/docs/ping/status-pages/">
								<div class="Title small">
									<span class="text">Status Pages</span>
									<span class="subtext">Learn how to configure public status pages with custom domain names.</span>
								</div>
							</a>

					</div>


				</div>

				<ImageUploader />

      </section>
		);
	}
}



// WEBPACK FOOTER //
// ./components/work/index.js